<div class="text-center">
  <span id="snackbar-text">{{ data.message }}</span>
  <a id="snackbar-link" [routerLink]="data.linkUrl" (click)="dismiss()">{{
    data.linkText
  }}</a>
  <button mat-button (click)="dismiss()">Close</button>
</div>
